<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <!-- <el-col :lg="5" :xl="5">
                    <el-form-item label="工厂编号" class="EL-Form-Item">
                        <el-select v-model="pagination.fcCode" placeholder="请选择">
                            <el-option v-for="item in factoryList" :key="item.fcId" :label="item.fcCode " :value="item.fcCode"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col> -->
                <el-col :lg="5" :xl="5">
                    <el-form-item label="订单编号" class="EL-Form-Item">
                        <el-input v-model="pagination.orderCode" placeholder="请输入" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="pagination.matCode" placeholder="请输入" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料描述" class="EL-Form-Item">
                        <el-input v-model="pagination.matName" placeholder="请输入" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="交易类型" class="EL-Form-Item">
                        <!-- <el-input v-model="pagination.tranType" placeholder="请输入" @change="saveSearch()">
                        </el-input> -->
						<el-select v-model="pagination.tranType" placeholder="请选择" filterable multiple collapse-tags clearable>
							<el-option v-for="(item,index) in tranTypeList" :key="index" :label="item.key" :value="item.key"></el-option>
						</el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="箱号" class="EL-Form-Item">
                        <el-input v-model="pagination.boxBarcode" placeholder="请输入" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                
                <el-col :lg="5" :xl="5">
                    <el-form-item label="通道" class="EL-Form-Item">
                        <el-input v-model="pagination.whCode" placeholder="请输入" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>

                <el-col :lg="5" :xl="5">
                    <el-form-item label="同步状态" class="EL-Form-Item">
                        <!-- <el-input v-model="pagination.syncFlag" placeholder="请输入" @change="saveSearch()">
                        </el-input> -->
                        <el-select v-model="pagination.syncFlag" placeholder="请选择" clearable="clearable">
							<el-option label="全部" value="">全部</el-option>
                            <el-option label="同步中" value="0">同步中</el-option>
                            <el-option label="已同步" value="1">已同步</el-option>
                            <el-option label="未同步" value="2">未同步</el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="操作人" class="EL-Form-Item">
                        <!-- <el-input v-model="pagination.person" placeholder="请输入" @change="saveSearch()">
                        </el-input> -->
                        <el-select v-model="pagination.person" placeholder="请选择" filterable clearable @change="saveSearch()">
							<el-option v-for="(item,index) in userList" :key="index" :label="item.userName" :value="item.userName"></el-option>
						</el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="操作人工号" class="EL-Form-Item">
                        <el-input v-model="pagination.personNumber" placeholder="请输入" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="10" :xl="10">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                      <el-date-picker style="width: 350px" v-model="pagination.requireDate" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"></el-date-picker>
                    </el-form-item>
                </el-col>


              <el-col :lg="5" :xl="5">
                <el-form-item label="仓库类型" class="EL-Form-Item">
                  <!-- <el-input v-model="pagination.person" placeholder="请输入" @change="saveSearch()">
                  </el-input> -->
                  <el-select v-model="pagination.saleFlag" placeholder="请选择" filterable clearable @change="saveSearch()">
                    <el-option label="全部" value="">全部</el-option>
                    <el-option label="寄售仓" value="1">寄售仓</el-option>
                    <el-option label="非寄售仓" value="0">非寄售仓</el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="5" :xl="5">
                <el-form-item label="批次号" class="EL-Form-Item">
                  <el-input v-model="pagination.batchNo" placeholder="请输入" @change="saveSearch()">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="5" :xl="5">
                <el-form-item label="工单号" class="EL-Form-Item">
                  <el-input v-model="pagination.opCode" placeholder="请输入" @change="saveSearch()">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="5" :xl="5">
                <el-form-item label="移入库位" class="EL-Form-Item">
                   <el-input v-model="pagination.lcCode" placeholder="请输入" @change="saveSearch()">
                   </el-input>
                  <!-- <el-cascader v-if="true" :key="keyValue" v-model="lcCodeList" :options="inventoryLocationList" :props="optionProps" collapse-tags clearable  @change="saveSearch()">
                   </el-cascader>-->
                 </el-form-item>
               </el-col>

               <el-col :lg="5" :xl="5">
                 <el-form-item label="移出库位" class="EL-Form-Item">
                   <el-input v-model="pagination.beforeLaCode" placeholder="请输入" @change="saveSearch()">
                   </el-input>
                 </el-form-item>
               </el-col>
              <el-col :lg="5" :xl="5">
                <el-form-item label="供应商" class="EL-Form-Item">
                  <el-input v-model="pagination.verdorCode" placeholder="请输入" @change="saveSearch()">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="5" :xl="5" v-if="roleCode !='外仓管理' ">

                <el-form-item label="仓库" class="EL-Form-Item">
                  <el-select v-model="pagination.fcType" placeholder="请选择" filterable clearable @change="saveSearch()">
                    <el-option key="0" value="" label="全部"></el-option>
                    <el-option label="内仓" value="NEC"> </el-option>
                    <el-option label="外仓" value="WC"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
             </el-form>
             <el-divider></el-divider>
             <plabel text="交易记录查询">
                 <!-- <span style="float:left">(未同步：{{notSynchronizedCount}})</span> -->
                <el-button v-authority="'BACK_MENU3_M8_B1'" class="btn-t-edit" type="primary" @click="setWxMessage()">修改消息体</el-button>
                <el-button v-authority="'BACK_MENU3_M8_B1'" class="btn-t-edit" type="primary" @click="prints()">单据打印</el-button>
                <el-button v-authority="'BACK_MENU3_M8_B2'" class="btn-t-edit" type="primary" @click="resend()">重新发送</el-button>
                <el-button v-authority="'BACK_MENU3_M8_B3'" class="btn-t-edit" type="primary" @click="confirmCompletion()">确认完成</el-button>
                <el-button v-authority="'BACK_MENU3_M8_B4'" class="btn-t-delete" type="primary" @click="deleteRecord()">删除</el-button>
                <el-button v-authority="'BACK_MENU3_M8_B8'" class="btn-t-delete" type="primary" @click="startAndStop()">系统启动与停止</el-button>
                <el-button v-authority="'BACK_MENU3_M8_B5'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table :summary-method="getSummaries" show-summary :headerCellStyle="headerCellStyle" style="flex: 1" :row-class-name="tableRowClassName" @pageChange="getAuxiMaterialData" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="pagination.total" @selectionChange="selectAll">
                <!-- <el-table-column type="selection" align="center" :selectable="checkboxSelect">
                </el-table-column> -->
                <el-table-column type="selection" align="center">
                </el-table-column>
                <el-table-column label="订单编号" prop="orderCode" align="center">
                </el-table-column>
              <el-table-column label="仓库类型" prop="saleFlag" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.saleFlag == 0">非寄售仓</span>
                  <span v-if="scope.row.saleFlag == 1">寄售仓</span>
                </template>
              </el-table-column>
                <el-table-column label="物料编号" prop="matCode" align="center">
                </el-table-column>
                <el-table-column label="物料描述" prop="matName" align="center">
                </el-table-column>
                <el-table-column label="数量" prop="matQuan" align="center">
                </el-table-column>
                <el-table-column label="交易类型" prop="tranType" align="center">
                </el-table-column>
                <el-table-column label="批次" prop="batchNo" align="center">
                </el-table-column>
                <el-table-column label="移出通道" prop="beforeWhCode" align="center">
                </el-table-column>
                <el-table-column label="移入通道" prop="whCode" align="center">
                </el-table-column>
                <el-table-column label="移出库位" prop="beforeLaCode" align="center">
                </el-table-column>
                <el-table-column label="移入库位" prop="laCode" align="center">
                </el-table-column>
                <el-table-column label="箱号" prop="boxBarcode" align="center">
                </el-table-column>
                <el-table-column label="交易时间" prop="createTime" align="center" width="140px">
                </el-table-column>
                <el-table-column label="原箱号" prop="oldBoxBarcode" align="center">
                </el-table-column>
                <el-table-column label="入库时间" prop="fifoDate" align="center" width="140px">
                </el-table-column>
                <el-table-column label="托盘编号" prop="palletCode" align="center">
                </el-table-column>
                <el-table-column label="供应商" prop="verdorCode" align="center">
                </el-table-column>
                <el-table-column label="供应商名称" prop="svName" align="center">
                </el-table-column>
                <el-table-column label="工单号" prop="opCode" align="center">
                </el-table-column>
                <el-table-column label="规值" prop="matSpecs" align="center">
                </el-table-column>

              <!--<el-table-column label="异常次数" prop="errorCount" align="center">
              </el-table-column>-->
              <!--<el-table-column label="消息体" prop="wxMessage" align="center" width="450px">
              </el-table-column>-->
                <el-table-column label="同步状态" prop="syncFlag" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.saleFlag == 1">不同步</span>
                         <span v-if="scope.row.saleFlag == 0">
                           <span v-if="scope.row.syncFlag == 0 && scope.row.errorCount == 0" >同步中</span>
                           <span v-if="scope.row.syncFlag == 1">已同步</span>
                           <span v-if="scope.row.syncFlag == 0 && scope.row.errorCount > 0">未同步</span>
                         </span>

                    </template>
                </el-table-column>
                <!-- <el-table-column label="状态" prop="syncFlag" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.syncFlag == 0 && scope.row.errorCount >= 4">待重发</span>
                        <span v-if="scope.row.syncFlag == 0 && scope.row.errorCount == 0">同步中</span>
                        <span v-if="scope.row.syncFlag == 0 && scope.row.errorCount > 0 && scope.row.errorCount < 4">同步中</span>
                    </template>
                </el-table-column> -->
                <el-table-column label="同步时间" prop="syncTime" align="center">
                </el-table-column>
                <el-table-column label="操作人" prop="person" align="center">
                </el-table-column>
                <el-table-column label="操作人工号" prop="personNumber" align="center">
                </el-table-column>
                <el-table-column label="描述" prop="tranTypeDesc" align="center">
                </el-table-column>
                <el-table-column label="操作" min-width="220px" fixed="right">
                    <template slot-scope="scope">
                        <el-button class="btn-t-edit" @click="openXaErrorLog(scope.row.wxError)" v-authority="'BACK_MENU3_M8_B6'" >错误信息</el-button> 
                        <el-button class="btn-t-edit" @click="openXaWhInventoryMessageDialog(scope.row)" v-authority="'BACK_MENU3_M8_B7'">XA库存信息</el-button> 
                    </template>
                </el-table-column>
            </h-table>
        </box>
         <el-dialog title="打印" :visible.sync="printShow" width="1200px" :close-on-click-modal="false">
            <div style="margin-top:20px;margin-left:900px">
                <el-button class="btn-t-info" type="info" @click="printShow = false; printList = []">取消</el-button>
                <el-button class="btn-t-edit" @click="print=true,printShow=false">打印</el-button>
            </div>
            <v-print :doPrint.sync="print">
                <div id="demo" class="demo">
                    <div>
                        <div style="font-size: 30px;font-weight: 600;margin-top: 20px;text-align: center;color: black;">
                            上架移库记录表
                        </div>
                        <div class="div" style="margin-top: 10px; font-size: 20px">
                            <!-- <span>日期：{{ timeDate }}</span>
                            <span>时间：{{ time }}</span> -->
                            <span>日期：{{ time }}</span>&nbsp;&nbsp;
                            <span>操作者：{{personName}}</span>
                        </div>
                        <div class="table">
                            <table width="100%" border="1" cellpadding="0" cellspacing="0">
                                <thead style="display:table-header-group;font-weight:bold">
                                    <tr style="height:50px">
                                        <th>序号</th>
                                        <th>型号</th>
                                        <th>批次</th>
                                        <!-- <th>规值</th> -->
                                        <th>数量</th>
                                        <th>箱号</th>
                                        <th>移出位置</th>
                                        <th>移入位置</th>
                                    </tr>
                                </thead>
                                <tr v-for="(item, index) in printList" :key="index" class="tr" style="height:50px">
                                    <td>{{index + 1}}</td>
                                    <td>{{item.matCode}}</td>
                                    <td>{{item.batchNo}}</td>
                                    <!-- <td>{{ item.matSpecs }}</td> -->
                                    <td>{{item.matQuan}}</td>
                                    <td>{{ item.boxBarcode }}</td>
                                    <td>{{item.beforeLaCode}}</td>
                                    <td>{{item.laCode}}</td>
                                </tr>
                                <!-- <tr class="tr">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr> -->
                            </table>
                        </div>
                    </div>
                </div>
            </v-print>
            <div style="margin-top: 50px;height:70px">
                <!-- <el-button class="btn-t-edit" @click="printShow = false; printList = [])">取消</el-button>
                <el-button class="btn-t-edit" @click="print=true,printShow=false,printObjList()">打印</el-button> -->
            </div>
        </el-dialog>

        <!-- 错误信息 -->
        <el-dialog :style="$popups.popups(0.45,0.35)" class="fromDialog" title="错误信息" :close-on-click-modal="false" :visible.sync="errorLogDialog">
            <el-form label-width="80px" style="height:500px">
                <el-col :lg="24" :xl="24">
                    <el-form-item label="错误信息:" prop="errorLog">
                        <el-input type="textarea" autosize v-model="errorLog"/>
                    </el-form-item>
                </el-col>
            </el-form>
        <!-- <span slot="footer" class="dialog-footer footer-bottom">
            <el-button size="small" type="info" @click="editBoxShow = false">关 闭</el-button>
        </span> -->
        </el-dialog>

      <el-dialog :style="$popups.popups(0.45,0.35)" class="fromDialog" title="" :close-on-click-modal="false" :visible.sync="xxDialog">
        <el-form label-width="80px" style="height:500px">
          <el-col :lg="24" :xl="24">
            <el-form-item label="消息体:" prop="newwxMessage">
              <el-input type="textarea" autosize v-model="newwxMessage"/>
            </el-form-item>
          </el-col>
        </el-form>
        <span slot="footer" class="dialog-footer footer-bottom">
            <el-button size="small" type="info" @click="xxDialog = false">关 闭</el-button>
            <el-button size="small" type="btn-t-edit" @click="updateWxMessage">确定</el-button>
        </span>
      </el-dialog>
        <el-dialog title="XA库位" :visible.sync="XaWhInventoryMessageDialog" class="infoDialog" :close-on-click-modal="false" :show-close="false">
            <h-table :headerCellStyle="headerCellStyle" style="height: 46vh" :data="XaWhInventoryMessageList">
                <el-table-column label="通道编号" align="center" prop="whCode"></el-table-column>
                <el-table-column label="物料编号" align="center" prop="matCode"></el-table-column>
                <el-table-column label="物料描述" align="center" prop="matName"></el-table-column>
                <el-table-column label="物料数量" align="center" prop="matQuan"></el-table-column>
                <el-table-column label="物料批次" align="center" prop="batchNo"></el-table-column>
                <el-table-column label="库位" align="center" prop="lcCode"></el-table-column>
                <el-table-column label="订单编号" align="center" prop="orderCode"></el-table-column>
                <el-table-column label="规值" prop="matSpecs" align="center">
                </el-table-column>
                <el-table-column label="入库时间" align="center" prop="matCreateTime" :formatter="dateFormat"></el-table-column>
            </h-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeXaWhInventoryMessageDialog" type="info">取 消</el-button>
            </div>
        </el-dialog>

        <!-- 系统启动与停止 -->
		<el-dialog title="系统启动与停止" :style="$popups.popups(0.2,0.2)" :visible.sync="startAndStopDialog" class="fromDialog" :close-on-click-modal="false" :show-close="false">
			<el-form label-position="right" label-width="90px" class="EL-Form">
                <el-col :lg="24" :xl="24">
                    <el-form-item label="系统交易状态" class="EL-Form-Item">
                        <el-select v-model="startAndStopStatus">
                            <el-option label="启动" value="1"></el-option>
                            <el-option label="停止" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="startAndStopDialog = false" type="info">取 消</el-button>
                <el-button @click="updateStartAndStop()" type="danger">确 定</el-button>
            </div>
		</el-dialog>
    </div>
</template>

<script>
import vPrint from "syl-vue-printer";
import htmlToPdf from "@/libs/htmlToPdf";
import moment from "moment";
    export default {
        name: "TransferWriteXA",
        components: {
            vPrint,
        },
        data() {
            return {
                headerCellStyle: () => {
                    return "background-color: #1f5cec";
                },
                form: {},
                xxDialog:false,
                newwxMessage:"",
                //主数据
                mainData: [],
                pagination: {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    fcCode: localStorage.getItem("fcCode"),
                    orderCode: "",
                    matCode: "",
                    matName: "",
                    tranType: "",
                    syncFlag: "",
                    person: "",
                    personNumber: "",
                    lcCode: "",
                    whCode: "",
                    auxiFlag: "",
                    boxBarcode:"",
                    errorCount: "0",
                    requireDate: [],
                    saleFlag:"0",
                    batchNo:"",
                    opCode:"",
                    svName:"",
                    beforeLaCode:"",
                    verdorCode:"",
                    fcType:localStorage.getItem("roleCode").indexOf("外仓") != -1 ?'WC':'NEC'
                },
                roleCode :localStorage.getItem("roleCode"),
                factoryList: [],

                inventoryLocationList: [],
                lcCodeList:[],
                keyValue: 1,
                optionProps: {
                  expandTrigger: 'hover',
                  //checkStrictly:true,
                  //emitPath:false,
                  multiple: true,
                  lazy: false,
                  lazyLoad: this.loadTechnologyId,
                  //value: 'lmId',
                  value: 'lmRealCode',
                  label: 'lmName',
                 children: 'sysLocationMenuPOList'
                },

                userList: [],

                downloadLoading: false, //下载中

                checkList: [],

                //打印
                print: false,
                printShow: false,
                printList: [],
                timeDate: "",
                person: localStorage.getItem("user"),
                personNumber: localStorage.getItem("empNumber"),
                time:moment().format("YYYY-MM-DD HH:mm:ss"),

                errorLogDialog: false,
                errorLog: "",   //错误日志信息显示

                //XA库存窗口
                XaWhInventoryMessageDialog: false,
                //XA库存数据
                XaWhInventoryMessageList:[],

                //用户名
                personName:"",

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,
				tranTypeList: [
					{key:'TW',value:'TW: Transfer Item'},
					//{key:'RW',value:'RW: Receive Transferred Item'},
					//{key:'IW',value:'IW: Issue Transferred Item'},
					{key:'RP',value:'RP: Receive Purchased Item to Stock'},
					//{key:'RD',value:'RD: Receive Purchased Item to Dock'},
					{key:'RI',value:'RI: Receive Purchased Item to Inspection'},
					//{key:'VR',value:'VR: Returned Purchased Item'},
					{key:'IS',value:'IS: Issue Item'},
					{key:'IA',value:'IA: Adjust Item Quantity'},
					//{key:'RM',value:'RM: Receive Production Item'},
					//{key:'IP',value:'IP: Issue Planned Production Component'},
					{key:'PQ',value:'PQ: PQ transactions'},
					{key:'SS',value:'SS: Scrap from stock'},
				],
                notSynchronizedCount:"",

                startAndStopDialog: false,
                startAndStopStatus: '1',
            };
        },
        watch: {
            pagination: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        //this.getAuxiMaterialData(newVal);
                    }, 1000)
                },
                deep: true,
            },
        },
        computed: {
            pickerOptions() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.pagination.requireDate[0]) {
                            return time.getTime() < new Date(_this.pagination.requireDate[0]);
                        }
                    }
                }
            },
            pickerOptions0() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.pagination.requireDate[1]) {
                            return time.getTime() > new Date(_this.pagination.requireDate[1]);
                        }
                    }
                }
            },
        },
        methods: {
            //禁选
            checkboxSelect(row, rowIndex) {
                if (row.syncFlag == 0) {
                    return true; // 禁用
                } else {
                    return false; // 不禁用
                }
            },

            tableRowClassName({row}) {
                if (row.syncFlag == 0 && row.errorCount > 0) {
                    return "success-row";
                }
            },

            //打开系统启动停止窗口
            startAndStop(){
                this.startAndStopDialog = true;
            },

            //启动或停止系统
            updateStartAndStop(){
                this.$confirm("是否启动或停止系统交易操作?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/writeXa/updateStartAndStop",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    startAndStopStatus: this.startAndStopStatus,
                                    fcCode: localStorage.getItem("fcCode"),
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.getAuxiMaterialData();
                                    this.$message({
                                        type: "success",
                                        message: "操作成功",
                                    });      
                                }else{
                                    this.$message({
                                        type: "error",
                                        message: "操作失败",
                                    });    
                                }
                            })
                            .catch((error) => {
                                this.loading++;
                            });   
                        })
                    .catch(() => {
                        this.insertStockReturnMats = false;
                        this.$message({
                            type: "info",
                            message: "已取消操作",
                        });
                    });      
            },

            //删除XA交易记录
            deleteRecord(){
                if (this.checkList.length == 0) {
                    this.$message({
                        message: "请选择至少一条交易记录进行删除操作！",
                        type: "warning",
                    });
                    return false;
                }else{
                    this.$confirm("是否确认删除此交易记录?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/writeXa/deleteRecord",
                                method: "DELETE",
                                showLoading: true,
                                params: {
                                    person: this.person,
                                    personNumber: this.personNumber,
                                },
                                data: this.checkList,
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.getAuxiMaterialData();
                                    this.$message({
                                        type: "success",
                                        message: "删除成功",
                                    });      
                                }else{
                                    this.$message({
                                        type: "error",
                                        message: "操作失败",
                                    });    
                                }
                            })
                            .catch((error) => {
                                this.loading++;
                            });   
                        })
                    .catch(() => {
                        this.insertStockReturnMats = false;
                        this.$message({
                            type: "info",
                            message: "已取消退料",
                        });
                    });  
                }  
            },

          setWxMessage(){
            if (this.checkList.length == 0 || this.checkList.length>1) {
              this.$message({
                message: "请选择一条交易记录进行操作！",
                type: "warning",
              });
              return false;
            }
            this.xxDialog = true;
            this.$http
                .request({
                  url: "/api/writeXa/getXaMessage",
                  method: "GET",
                  showLoading: true,
                  params: {
                    wxId: this.checkList[0].wxId,
                  },
                })
                .then((resp) => {
                  if (resp.status == 100) {
                    this.newwxMessage = resp.data.wxMessage;
                  }else{
                    this.$message({
                      type: "error",
                      message: "操作失败",
                    });
                  }
                })
                .catch((error) => {

                });


          },
          //
          updateWxMessage(){
            if (this.checkList.length == 0 || this.checkList.length>1) {
              this.$message({
                message: "请选择一条交易记录进行操作！",
                type: "warning",
              });
              return false;
            }else{
              this.$confirm("是否确认修改此交易记录?", "提示", {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                type: "warning",
              })
                  .then(() => {
                    this.$http
                        .request({
                          url: "/api/writeXa/updateWxMessage",
                          method: "POST",
                          showLoading: true,
                          params: {
                            person: this.person,
                            personNumber: this.personNumber,
                            wxMessage:this.newwxMessage,
                            wxId:this.checkList[0].wxId,
                          },

                        })
                        .then((resp) => {
                          if (resp.status == 100) {
                            this.logRemarks = "writeXa：修改消息体成功"+this.checkList[0].wxId;
                            this.systemLog();
                            this.getAuxiMaterialData();
                            this.$message({
                              type: "success",
                              message: "修改成功",
                            });

                          }else{
                            this.$message({
                              type: "error",
                              message: "操作失败",
                            });
                          }
                        })
                        .catch((error) => {
                          this.loading++;
                        });
                  })
                  .catch(() => {
                    this.insertStockReturnMats = false;
                    this.$message({
                      type: "info",
                      message: "已取消退料",
                    });
                  });
            }
          },
            // 打开XA回写错误信息窗口
            openXaErrorLog(errorLog){
                this.errorLog = errorLog;
                this.errorLogDialog = true;
            },
            // 打开XA交易窗口
            openXaWhInventoryMessageDialog(item){
                this.getXaWhInventoryMessage(item);
            },
            // 关闭XA交易窗口
            closeXaWhInventoryMessageDialog(){
                this.XaWhInventoryMessageDialog = false;
                this.XaWhInventoryMessageList = [];
            },
            dateFormat(row, column) {
                var date = row[column.property];
                if (date == undefined) {
                    return "";
                }
                return moment(date).format("YYYY-MM-DD");
            },
            // 获取XA交易库存信息
            getXaWhInventoryMessage(item){
                this.$http
                    .request({
                        url: "/api/writeXa/getXaWhInventoryMessage",
                        method: "GET",
                        showLoading: true,
                        params: {
                            batchNo: item.batchNo,
                            laCode: item.laCode,
                            fcCode: localStorage.getItem("fcCode"),
                            item: item.matCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.XaWhInventoryMessageList = resp.data.list || [];
                            this.XaWhInventoryMessageDialog = true;
                        }else{
                            this.$message({
                                type: "error",
                                message: "操作失败",
                            });    
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });    
            },

            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value)) && (column.property == "matQuan" || column.property == "matDistrQuan" ||column.property == "matAvaliableQuan")) {
                    sums[index] = values.reduce((prev, curr) => {
                    const value = Number(curr);
                    if (!isNaN(value)) {
                        return prev + curr;
                    } else {
                        return prev;
                    }
                    }, 0);
                    sums[index];
                } 
                });

                return sums;
            },

            handleDown() {
                // console.log(document.querySelector("#demo"));
                htmlToPdf.downloadPDF(document.querySelector("#demo"), "X-R控制图");
            },
            // 获取所有的用户
            getUserAll() {
                this.$http
                    .request({
                        url: "/api/user/userAll",
                        method: "GET",
                        params: {},
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.userList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            //全选
            selectAll(val) {
                this.checkList = val;
            },
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy)
                window.lazy = window.setTimeout(() => {
                    this.getAuxiMaterialData()
                }, 1000)
            },
            //获取未同步数量
            getNotSynchronizedCount(){
                this.$http
                    .request({
                        url: "/api/writeXa/getWriteXaAll",
                        method: "GET",
                        params: {
                            pageNum: this.pagination.pageNum || null,
                            pageSize: this.pagination.pageSize || null,
                            fcCode: this.pagination.fcCode || null,
                            orderCode: this.pagination.orderCode || null,
                            matCode: this.pagination.matCode || null,
                            tranType: this.pagination.tranType?this.pagination.tranType.join(","):null,
                            syncFlag: "0" || null,
                            person: this.pagination.person || null,
                            personNumber: this.pagination.personNumber || null,
                            lcCode: this.pagination.lcCode || null,
                            whCode: this.pagination.whCode || null,
                            boxBarcode: this.pagination.boxBarcode || null,
                            auxiFlag: this.pagination.auxiFlag || null,
                            beginTime: this.pagination.requireDate[0] || null,
                            endTime: this.pagination.requireDate[1] || null,
                            errorCount: "1" || null,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.notSynchronizedCount = resp.data.total || [];
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });    
            },
            //获取数据
            getAuxiMaterialData() {
                var syncFlag = "";
                var errorCount = "";
                if(this.pagination.syncFlag == ""){
                    syncFlag = ""
                    errorCount = "";   
                }else if(this.pagination.syncFlag == "1"){
                    syncFlag = "1"
                    errorCount = "";     
                }else if(this.pagination.syncFlag == "0"){
                    syncFlag = "0"
                    errorCount = "0";     
                }else if(this.pagination.syncFlag == "2"){
                    errorCount = "1";
                    syncFlag = "0";      
                }
                if (this.pagination.requireDate[0] == null || this.pagination.requireDate[1] == null ) {
                  this.$message({
                    message: "时间不能为空",
                    type: "warning",
                  });
                  return;
                }
                // const timeDiff = Math.abs(new Date(this.pagination.requireDate[1]).getTime() - new Date(this.pagination.requireDate[0]).getTime());
                // if (this.pagination.boxBarcode != '' || this.pagination.matCode != '' || this.pagination.matName != '' || this.pagination.syncFlag == '2') {
                //   if (Math.ceil(timeDiff / (1000 * 3600 * 24)) > 365) {
                //     this.$message({
                //       message: "通过箱号、物料、未同步查询只能查询一年区间的记录",
                //       type: "warning",
                //     });
                //     return;
                //   }
                // } else {
                //   if (Math.ceil(timeDiff / (1000 * 3600 * 24)) > 4) {
                //     this.$message({
                //       message: "开始时间与结束时间间隔不能超过三天",
                //       type: "warning",
                //     });
                //     return;
                //   }
                //
                // }


                //this.pagination.lcCode = "";
                this.lcCodeList.forEach((item) => {
                  this.pagination.lcCode += item[item.length - 1] + ","
                })
                this.$http
                    .request({
                        url: "/api/writeXa/getWriteXaList",
                        method: "GET",
                        params: {
                            pageNum: this.pagination.pageNum || null,
                            pageSize: this.pagination.pageSize || null,
                            fcCode: this.pagination.fcCode || null,
                            orderCode: this.pagination.orderCode || null,
                            matCode: this.pagination.matCode || null,
                            tranType: this.pagination.tranType?this.pagination.tranType.join(","):null,
                            syncFlag: syncFlag || null,
                            person: this.pagination.person || null,
                            personNumber: this.pagination.personNumber || null,
                            lcCode: this.pagination.lcCode || null,
                            whCode: this.pagination.whCode || null,
                            boxBarcode: this.pagination.boxBarcode || null,
                            auxiFlag: this.pagination.auxiFlag || null,
                            beginTime: this.pagination.requireDate[0] || null,
                            endTime: this.pagination.requireDate[1] || null,
                            errorCount: errorCount || null,
                            matName: this.pagination.matName || null,
                            saleFlag: this.pagination.saleFlag || null,
                            batchNo:this.pagination.batchNo || null,
                            opCode:this.pagination.opCode || null,
                            svName:this.pagination.svName || null,
                            beforeLaCode:this.pagination.beforeLaCode,
                            verdorCode:this.pagination.verdorCode,
                            fcType: this.pagination.fcType,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.mainData = resp.data.list || [];
                            this.pagination.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },

          /**
           * 根据仓库类型获取所有货位类型货位号信息
           */
          getLocationMenus() {
            this.$http
                .request({
                  url: "/api/location/getLocationMenus",
                  method: "GET",
                  params: {
                    lmId: 3,
                    fcCode: localStorage.getItem("fcCode") || "",
                  },
                })
                .then((resp) => {
                  if (resp.status == 100) {
                    if (resp.data.total != 0) {
                      this.inventoryLocationList = resp.data.list
                      var lcPs= {};
                      lcPs.lmId=66;
                      lcPs.lmName='PS000';
                      lcPs.lmRealCode= 'PS000';
                      lcPs. solidFlag=true;
                      this.inventoryLocationList.push(lcPs);
                      var lcRet= {}
                      lcRet.lmId=66;
                      lcRet.lmName='RET';
                      lcRet.lmRealCode= 'RET';
                      lcRet. solidFlag=true;
                      this.inventoryLocationList.push(lcRet)
                      var lcTK= {}
                      lcTK.lmId=66;
                      lcTK.lmName='TK000';
                      lcTK.lmRealCode= 'TK000';
                      lcTK. solidFlag=true;
                      this.inventoryLocationList.push(lcTK)
                    }
                  } else {
                    this.$message({
                      message: resp.message,
                      type: "error",
                    });
                  }
                })
                .catch((error) => {
                  this.$message({
                    message: "操作失败",
                    type: "error",
                  });
                });
          },
            // 确认完成
            confirmCompletion(){
                if (this.checkList.length != 1) {
                    this.$message({
                        message: "请选择一条未同步的交易记录再确认完成！",
                        type: "warning",
                    });
                    return false;
                }else{
                    this.$confirm("是否确认此交易记录已经完成?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/writeXa/confirmCompletion",
                                method: "POST",
                                params: {
                                    wxId: this.checkList[0].wxId
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        type: "success",
                                        message: "操作成功",
                                    });
                                  this.logRemarks = "writeXa：交易确认完成"+this.checkList[0].wxId;
                                  this.systemLog();
                                }else{
                                    this.$message({
                                        type: "success",
                                        message: "操作失败",
                                    });    
                                }
                                this.getAuxiMaterialData();
                            })
                            .catch((error) => {
                                this.loading++;
                            });    
                    })
                    .catch(() => {
                        this.insertStockReturnMats = false;
                        this.$message({
                            type: "info",
                            message: "已取消退料",
                        });
                    });    
                }  
            },
            //获取工厂数据
            getFactoryAll() {
                this.$http
                    .request({
                        url: "/api/factory/getFactoryAll",
                        method: "GET",
                        params: {},
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.factoryList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            //重置
            resetData() {
                this.pagination = {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    fcCode: localStorage.getItem("fcCode"),
                    orderCode: "",
                    matCode: "",
                    matName: "",
                    tranType: "",
                    syncFlag: "",
                    person: "",
                    personNumber: "",
                    lcCode: "",
                    whCode: "",
                    auxiFlag: "",
                    svName:"",
                    errorCount: "0",
                    requireDate: []
                },
                this.getAuxiMaterialData();
            },
            //重新发送
            resend() {
                let hint = ""
                if (this.checkList.length == 0) {
                  this.$message({
                    message: "请选择一条未同步的交易记录！",
                    type: "warning",
                  });
                    return;
                } else {
                    hint = "选择记录确认重新发送, 是否继续?"
                }
              this.checkList.forEach(function(c) {
                c.createTime = '';
                c.fifoDate = '';
              })
                this.$confirm(hint, "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/writeXa/updateResend",
                                method: "POST",
                                showLoading: true,
                                data: this.checkList,
                                params: {
                                    person: localStorage.getItem("user"),
                                    personNumber: localStorage.getItem("empNumber")
                                }
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                  this.logRemarks = "writeXa：重新发送操作成功"+this.checkList[0].wxId;
                                    this.getAuxiMaterialData();
                                } else {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "writeXa：重新发送操作失败";
                                }
                                this.systemLog();
                            })
                            .catch((error) => {
                                this.loading++;
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            },

            prints() {
                if (this.checkList.length == 0) {
                    this.$message({
                    message: "请选择打印单！",
                    type: "warning",
                    });
                    return;
                }
                this.printList = this.checkList;
                console.log(this.printList);
                if(this.pagination.person == ""){
                    this.getUserName(this.person);
                }else{
                    this.getUserName(this.pagination.person);
                }
                this.printShow = true;
                this.getTime();
                },
            /**
             * 根据用户名查询名称
             *  
             * */    
            getUserName(person){
                this.$http
                    .request({
                        url: "/api/user/userAll",
                        method: "GET",
                        params: {
                            userAccount: this.person,
                            pageNum: "1",
                            pageSize: "999999",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.personName = resp.data.list[0].userName || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

            /**
             * 获取当前时间
             * 格式YYYY-MM-DD
             */
            getTime() {
            var date = new Date();
            var seperator1 = "/";
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            this.timeDate = year + seperator1 + month + seperator1 + strDate;
            },

            //表格导出
            downLoadFile() {

                var syncFlag = "";
                var errorCount = "";
                if(this.pagination.syncFlag == ""){
                    syncFlag = ""
                    errorCount = "";   
                }else if(this.pagination.syncFlag == "1"){
                    syncFlag = "1"
                    errorCount = "";     
                }else if(this.pagination.syncFlag == "0"){
                    syncFlag = "0"
                    errorCount = "0";     
                }else if(this.pagination.syncFlag == "2"){
                    errorCount = "1";
                    syncFlag = "0";      
                }
              if (this.pagination.requireDate[0] == null || this.pagination.requireDate[1] == null ) {
                this.$message({
                  message: "时间不能为空",
                  type: "warning",
                });
                return;
              }
              // const timeDiff = Math.abs(new Date(this.pagination.requireDate[1]).getTime() - new Date(this.pagination.requireDate[0]).getTime());
              //
              //   if (Math.ceil(timeDiff / (1000 * 3600 * 24)) > 31) {
              //     this.$message({
              //       message: "只能导出一个月的记录",
              //       type: "warning",
              //     });
              //     return;
              //   }
              this.downloadLoading = true;
              var paramsObj = {
                    fcCode: this.pagination.fcCode || null,
                    orderCode: this.pagination.orderCode || null,
                    matCode: this.pagination.matCode || null,
                    tranType: this.pagination.tranType?this.pagination.tranType.join(","):null,
                    syncFlag: syncFlag || null,
                    person: this.pagination.person || null,
                    personNumber: this.pagination.personNumber || null,
                    lcCode: this.pagination.lcCode || null,
                    whCode: this.pagination.whCode || null,
                    boxBarcode: this.pagination.boxBarcode || null,
                    auxiFlag: this.pagination.auxiFlag || null,
                    beginTime: this.pagination.requireDate[0] || null,
                    endTime: this.pagination.requireDate[1] || null,
                    errorCount: errorCount || null,
                    matName: this.pagination.matName || null,
                    saleFlag: this.pagination.saleFlag || null,
                    batchNo:this.pagination.batchNo || null,
                    opCode:this.pagination.opCode || null,
                    svName:this.pagination.svName || null,
                    pageNum: 1,
                    beforeLaCode:this.pagination.beforeLaCode,
                    verdorCode:this.pagination.verdorCode,
                    fcType: this.pagination.fcType,
                    pageSize: 999999,
                }

                this.$http.request({
                    url: '/api/writeXa/getWriteXaList',
                    method: 'GET',
                    showLoading: true,
                    params: paramsObj
                }).then((resp) => {
                    if(resp.data.total != 0){
                        resp.data.list.forEach((item)=>{
                            item.syncStatus = "";
                        })
                    }
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {

                        // if(c.syncFlag == 0 && c.errorCount >= 4){
                        //     c['syncStatus'] = '待重发'
                        // } else if(c.syncFlag == 0 && c.errorCount == 0){
                        //     c['syncStatus'] = '同步中'
                        // } else if(c.syncFlag == 0 && c.errorCount > 0 && c.errorCount < 4){
                        //     c['syncStatus'] = '同步中'
                        // }

                        if (c.syncFlag == 0 && c.errorCount == 1) {
                            c['syncFlag'] = '未同步'
                        } else if (c.syncFlag == 0 && c.errorCount == 0) {
                            c['syncFlag'] = '同步中'
                        } else if (c.syncFlag == 1) {
                            c['syncFlag'] = '已同步'
                        }

                        if (c.saleFlag == 0 ){
                          c['saleFlag'] = "非寄售仓";
                        }else if(c.saleFlag == 1 ) {
                          c['saleFlag'] = "寄售仓";
                        }

                        // if (c.tranType == "TW") {
                        //     c['tranType'] = 'TW: Transfer Item'
                        // } else if (c.tranType == "RW") {
                        //     c['tranType'] = 'RW: Receive Transferred Item'
                        // } else if (c.tranType == "IW") {
                        //     c['tranType'] = 'IW: Issue Transferred Item'
                        // } else if (c.tranType == "RP") {
                        //     c['tranType'] = 'RP: Receive Purchased Item to Stock'
                        // } else if (c.tranType == "RD") {
                        //     c['tranType'] = 'RD: Receive Purchased Item to Dock'
                        // } else if (c.tranType == "RI") {
                        //     c['tranType'] = 'RI: Receive Purchased Item to Inspection'
                        // } else if (c.tranType == "VR") {
                        //     c['tranType'] = 'VR: Returned Purchased Item'
                        // } else if (c.tranType == "IS") {
                        //     c['tranType'] = 'IS: Issue Item'
                        // } else if (c.tranType == "IA") {
                        //     c['tranType'] = 'IA: Adjust Item Quantity'
                        // } else if (c.tranType == "RM") {
                        //     c['tranType'] = 'RM: Receive Production Item'
                        // } else if (c.tranType == "IP") {
                        //     c['tranType'] = 'IP: Issue Planned Production Component'
                        // } else if (c.tranType == "PQ") {
                        //     c['tranType'] = 'PQ: PQ transactions'
                        // } else if (c.tranType == "SS") {
                        //     c['tranType'] = 'SS: Scrap from stock'
                        // }
                        
                    })
                    const tHeader = ["订单编号","仓库类型","物料编号","物料描述","数量","交易类型","批次","移出通道","移入通道","移出库位","移入库位","箱号","原箱号","入库时间","托盘编号","供应商","供应商名称","工单号","规值","交易时间","同步状态","同步时间","操作人",'操作人工号','描述']
                    const filterVal = ["orderCode","saleFlag","matCode","matName","matQuan","tranType","batchNo","beforeWhCode","whCode","beforeLaCode","laCode","boxBarcode","oldBoxBarcode","fifoDate","palletCode","verdorCode","svName","opCode","matSpecs","createTime","syncFlag","syncTime","person",'personNumber','tranTypeDesc']
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '交易记录报表数据'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "sys_warehouse：导出交易记录报表数据"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "回写XA系统报表",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },

        },
        activated(){
          this.pagination.requireDate = [];
          this.pagination.requireDate.push(moment().subtract("d", 3).format("YYYY-MM-DD")+ ' 00:00:00');
          this.pagination.requireDate.push(moment().format("YYYY-MM-DD")+ ' 23:59:59');
          //this.pagination.requireDate.push(moment().subtract("d", 3).format("YYYY-MM-DD"+ ' 00:00'));
          //this.pagination.requireDate.push(moment().add("d", 1).format("YYYY-MM-DD" + ' 23:59'));
            this.getFactoryAll();
            /* 获取首页的数据 */
            this.getAuxiMaterialData();
            // 获取所有用户
            this.getUserAll();
            this.getLocationMenus();
           // this.getNotSynchronizedCount();
        },
    };
</script>
<style>
    .success-row {
        color: #ff0000;
    }
</style>
<style scoped>
    
    .div span {
        margin-left: 50px;
    }

    .table table {
        margin-top: 20px;
    }

    .table table tr td {
        width: 100px;
        height: 50px;
        border: 1px solid black;
        text-align: center;
    }

    .table table tr th {
        width: 100px;
        height: 80px;
        border: 1px solid black;
        font-weight: 800;
        font-size: 18px;
    }

    .td td {
        font-weight: 800;
    }
</style>